import { createContext, useEffect, useState } from "react";
import io from "socket.io-client";
import { useAuth } from "./AuthContext";
import { getCurrentLang } from "../utils/lang";
import { MainUrl, Ws } from "../Api/constants";

const SocketContext = createContext(null);
export const SocketProvider = ({ children }) => {
  const [socket, setSocket] = useState(null);
  const { isLoggedIn, token, user } = useAuth();
  // console.log("user", user);
  useEffect(() => {
    if (isLoggedIn && token) {
      const currentLang = getCurrentLang();
      const newSocket = io(MainUrl, {
        path: Ws,
        extraHeaders: {
          Authorization: token,
          Local: currentLang,
        },
      });
      setSocket(newSocket);
      const OnConnect = () => {
        newSocket.emit("Client", {
          command: "Organization",
          params: {
            Org: window.location?.origin?.replace(/^https?:\/\//, ""),
          },
        });
      };
      newSocket.on("connect", OnConnect);
      return () => {
        newSocket.off("connect", OnConnect);
        newSocket.close();
      };
    }
  }, [isLoggedIn, token]);
  useEffect(() => {
    if (socket && user?.CustomerId) {
      socket.emit("Client", {
        command: "Verify",
        body: {
          Id: user?.CustomerId,
          Type: "Online", // "Offline" Or "Online"
        },
      });
    }
  }, [socket, user?.CustomerId]);
  return (
    <SocketContext.Provider value={socket}>{children}</SocketContext.Provider>
  );
};

export default SocketContext;
